<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <!-- <div class="page_title">
            ABN
        <el-progress class="progress" :percentage="50" :show-text="false" color="#2463FF" />
        </div> -->

        <div class="container onboarding">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>ABN</h1>
                    <p class="auth-subtext">Provide your Australian Business Number to proceed.</p>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>
            <el-form :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="goNext('userForm')">
                <!-- <div class="form_text">
                    <div class="text">
                        Provide your Australian Business Number to proceed.
                    </div>
                </div> -->
                <el-form-item label="Australian Business Number" prop="abn" :required='true'
                    class="is-no-asterisk el-input">
                    <input type="tel" class="el-input__inner" :ref='el => formsData.userForm.abn.ref = el'
                        :value="formsData.userForm.abn.value" :placeholder="'00 000 000 000'"
                        v-imask="formsData.userForm.abn.mask" @accept="onFormMaskAccept($event, 'userForm', 'abn')"
                        @blur="checkFormValidation('userForm', true, 'abn')">
                </el-form-item>
                <el-form-item class="button_submit mt-auto mb0">
                    <el-button class="submit" type="blue" @click="goNext('userForm')"
                        :disabled="formsData.userForm.disabled">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {
        onMounted,
        inject
    } from 'vue';

    import {
        addIcons
    } from 'ionicons'
    import {
        arrowBackOutline
    } from 'ionicons/icons'
    addIcons({
        'arrow-back-outline': arrowBackOutline
    })
    import {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
    } from '@ionic/vue';

    import {
        useStore
    } from 'vuex'
    import {
        useRouter,
        useRoute
    } from 'vue-router'
    import formHooks from '@/hooks/form/form'
    import formValidate from '@/hooks/form/validate/validate'
    import formMasks from '@/hooks/form/mask/mask'

    import IMaskDirective from '@/directives/vue-imask/directive';
    import IMask from 'imask/esm/imask';
    import SvgIcon from '@/components/Svg/SvgIcon.vue'; 

    export default {
        components: {
            IonToolbar,
            IonButton,
            IonButtons,
            IonIcon,
            SvgIcon
        },
        directives: {
            imask: IMaskDirective
        },
        setup() {
            const $store = useStore()
            const $router = useRouter()
            const $route = useRoute()
            const setPageClassGlobal = inject('setPageClassGlobal');

            const userData = $store.getters.GET_USER_DATA;
            const abn = userData.abn;

            const formsDataArray = {
                userForm: {
                    abn: {
                        value: abn ? IMask.createMask(formMasks.abn).resolve(abn) : '',
                        mask: formMasks.abn,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'abn', callback, setFormValidation);
                            },
                        }]
                    },
                }
            };

            const goBack = async() => {
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });  
            };

            const goNext = (formName) => {
                formsRefs[formName].value.validate((valid) => {
                    if (valid) {
                        (async () => {
                            try {
                                await $store.dispatch('SAVE_USER_DATA', getFormValues(formName));
                                $router.push({
                                    name: 'additional_name',
                                })
                            } catch (error) {
                                console.log('error submit!!');
                            }
                        })();
                    } else {
                        setFormValidation(formName, false, false);
                        console.log('error submit!!');
                        return false;
                    }
                });
            };

            const skip = () => {
                $store.dispatch('addAuthPageBack', $route.name);
                $router.push({
                    name: 'additional_name',
                })
            }

            onMounted(() => {
                setPageClassGlobal('global_auth_page');
                setFormRefs();
                formsRefs.userForm.value.$el[0].focus();
                checkFormValidation('userForm', false);
            });

            const {
                onFormMaskAccept,
                checkFormValidation,
                setFormValidation,
                getFormValues,
                setFormRefs,
                formsData,
                formsRefs,
            } = formHooks(formsDataArray);

            return {
                formsData,
                onFormMaskAccept,
                checkFormValidation,
                goBack,
                goNext,
                skip
            }
        },
    }
</script>